<div class="container down">

 <div class="row justify-content-center">
   <div class="col-md-6 ">
    <div class="row justify-content-center">
      <div class="col-md-4">



      <div class="col-md-12 mt-5 submit">
        <div class="item">
          <ngx-skeleton-loader count="1"  appearance="circle"
          [theme]="{
            width: '100%',
            'border-radius': '10px',
            height: '60px',
            'background-color': 'rgb(226, 225, 225)',
            'margin-bottom': '10px'
          }"
          > </ngx-skeleton-loader>
        </div>
      </div>

      </div>

      <div class="col-md-4">



        <div class="col-md-12 mt-5 submit">
          <div class="item">
            <ngx-skeleton-loader count="1"  appearance="circle"
            [theme]="{
              width: '100%',
              'border-radius': '10px',
              height: '60px',
              'background-color': 'rgb(226, 225, 225)',
              'margin-bottom': '10px'
            }"
            > </ngx-skeleton-loader>
          </div>
        </div>

        </div>

        <div class="col-md-4">



            <div class="col-md-12 mt-5 submit">
              <div class="item">
                <ngx-skeleton-loader count="1"  appearance="circle"
                [theme]="{
                  width: '100%',
                  'border-radius': '10px',
                  height: '60px',
                  'background-color': 'rgb(226, 225, 225)',
                  'margin-bottom': '10px'
                }"
                > </ngx-skeleton-loader>
              </div>
            </div>

            </div>
    </div>
   </div>
 </div>
</div>
